<template>
  <el-form-item :label="$attrs.label" :prop="$attrs.name" class="elsa-input required" :ref="$attrs.name">
    <template slot="label" v-if="information">
      {{ $attrs.label }}
      <el-tooltip v-if="information" :content="information" popper-class="white-space-pre-line">
        <i class="el-icon-info" />
      </el-tooltip>
    </template>
    <treeselect
      ref="$select"
      :value="value"
      :multiple="true"
      :options="treeOptions"
      :placeholder="$attrs.placeholder"
      :clearable="false"
      :limitText="limitTextFunction"
      :limit="1"
      :default-expand-level="2"
      :loadOptions="loadOptions"
      :auto-load-root-options="false"
      :openDirection="'below'"
      value-consists-of="LEAF_PRIORITY"
      @open="onToggleIcon"
      @close="onToggleIcon"
      @input="onInput"
    />
    </el-form-item>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: { Treeselect },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    information: {
      type: String,
      default: ''
    },
    loadOptions: {
      type: Function,
      default: () => {}
    },
    selectAll: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      $arrowIcon: null,
      $clear: null
    }
  },
  computed: {
    treeOptions() {
      if (!this.options.length) {
        return []
      }

      if (!this.selectAll) {
        return this.options
      }

      return [{
        id: 'select-all',
        label: 'Select All',
        children: this.options
      }]
    }
  },
  watch: {
    value(val) {
      if (!this.$clear) {
        return
      }

      this.$clear.classList.toggle('hidden', !val.length)
    }
  },
  async mounted() {
    await this.$nextTick()

    const selectEl = this.$refs['$select']
    if (!selectEl || !selectEl.$el) {
      return
    }

    const arrowContainer = selectEl.$el.querySelector('.vue-treeselect__control-arrow-container')
    await this.$nextTick()
    if (arrowContainer) {
      arrowContainer
        .appendChild(document.createElement('i'))
        .classList.add(...['el-select__caret', 'el-input__icon', 'el-icon-arrow-down'])
    }

    if (this.clearable) {
      this.$clear = document.createElement('div')
      this.$clear.setAttribute('class', 'clear hidden')
      this.$clear.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 348.333 348.333">
          <path d="M336.559 68.611L231.016 174.165l105.543 105.549c15.699 15.705 15.699 41.145 0 56.85-7.844 7.844-18.128 11.769-28.407 11.769-10.296 0-20.581-3.919-28.419-11.769L174.167 231.003 68.609 336.563c-7.843 7.844-18.128 11.769-28.416 11.769-10.285 0-20.563-3.919-28.413-11.769-15.699-15.698-15.699-41.139 0-56.85l105.54-105.549L11.774 68.611c-15.699-15.699-15.699-41.145 0-56.844 15.696-15.687 41.127-15.687 56.829 0l105.563 105.554L279.721 11.767c15.705-15.687 41.139-15.687 56.832 0 15.705 15.699 15.705 41.145.006 56.844z">
          </path>
        </svg>`
      const $valueContainer = selectEl.$el.querySelector('.vue-treeselect__value-container')

      if ($valueContainer) {
        $valueContainer.after(this.$clear)
        this.$clear.addEventListener('click', this.onClickClearHandler)
      }
    }
  },
  methods: {
    onClickClearHandler() {
      this.$emit('clear')
    },
    onToggleIcon() {
      const $select = this.$refs['$select']
      if (!this.$arrowIcon) {
        this.$arrowIcon = $select.$el.querySelector('.el-icon-arrow-down')
      }

      if (this.$arrowIcon) {
        this.$arrowIcon.classList.toggle('el-icon-arrow-down--reverse')
      }
    },
    onInput(items) {
      this.$emit('input', items)
    },
    limitTextFunction(count) {
      return `+${count}`
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .clear {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #C0C4CC;
    width: 20px;
    height: 20px;
    cursor: pointer;

    &:hover {
      color: red;
    }
    
    svg {
      width: 8px;
      height: 8px;
    }
  }
  .el-icon-arrow-down {
    transition: transform .3s;
    transform: rotateZ(0);
    &--reverse {
      transform: rotateZ(-180deg);
    }
  }
  .hidden {
    display: none;
  }
  .vue-treeselect__control {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    height: 50px;
    padding: 5px 7px;
    border-color: #d1d1d6;

    .vue-treeselect--open & {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  .vue-treeselect__multi-value {
    display: flex;
    align-items: center;
    height: 34px;
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }

  .vue-treeselect__multi-value-item-container {
    padding-top: 0;
  }

  .vue-treeselect__multi-value-label {
    line-height: 14px;
  }

  .vue-treeselect__multi-value-item {
    display: flex;
    align-items: center;
    background-color: #f4f4f5;
    border-color: #e9e9eb;
    color: #909399;
    border-radius: 4px;
    padding: 0 5px;
    height: 30px;
  }
  .vue-treeselect__menu {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    top: 0;
    margin-top: -1px;
    border-top-color: #f2f2f2;
    -webkit-box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
    max-height: unset !important;
    overflow: hidden;
    > .vue-treeselect__list {
      max-height: 350px;
      overflow: auto
    }
  }

  .vue-treeselect__value-remove {
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    background-color: #C0C4CC;
    height: 15px;
    border-radius: 50%;
    color: #909399;

    svg {
      width: 5px;
      height: 5px;
    }
  }

  .vue-treeselect__control-arrow {
    display: none;
  }

  .vue-treeselect__control-arrow-container {
    i {
      &::before {
        color: #C0C4CC;
      }
    }
  }
  .vue-treeselect__limit-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f4f4f5;
    color: #909399;
    border-radius: 4px;
    border: 1px solid #e9e9eb;
    height: 30px;
    padding: 5px 7px;
  }
  .vue-treeselect__x-container {
    i {
      display: none;
    }
  }
}
</style>